window.theme = window.theme || {};
//Carousel
var carousel = function(element){
  if(element.length > 0 && element.hasClass('carousel')){
    var slidesToShow = element.data('items-per-slide') ? element.data('items-per-slide') : 4;
    var slidesToShowSmall = element.data('items-small') ? element.data('items-small') : 3;
    var slidesToShowMediumUp = element.data('items-medium-up') ? element.data('items-medium-up') : 4;
    var slidesToShowLargeUp = element.data('items-large-up') ? element.data('items-large-up') : 5;
    element.slick({
      infinite: false,
      speed: 300,
      slidesToShow: slidesToShow,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: slidesToShowLargeUp,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 990,
          settings: {
            slidesToShow: slidesToShowMediumUp,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 750,
          settings: {
            slidesToShow: slidesToShowSmall,
            slidesToScroll: 1
          }
        }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ]
	});
  }
};
//Instagram feed
theme.InstagramFeed = (function() {
    function InstagramFeed(container) {
        var $container = this.$container = $(container);
        var sectionId = $container.attr('data-section-id');
        var $instagramFeed = '#InstagramFeed-' + sectionId;

        this._initFeed($instagramFeed);
    }

    InstagramFeed.prototype = _.assignIn({}, InstagramFeed.prototype, {
        _initFeed: function(el) {
            var $el = $(el);
            var $wrapper = $el.find('.instagram-feed__wrapper');
            var is_carousel =  $el.attr('data-carousel');
            var $template = $el.siblings('.instagram-feed__template').html();

            var options = {
                target: $wrapper[0],
                get: 'user',
                userId: $el.data('user'),
                accessToken: $el.data('token'),
                limit: $el.data('limit'),
                resolution: 'standard_resolution',
              	after: function(){
                  if(is_carousel == '1'){
                    carousel($wrapper);
                  }                  
                },
                template: $template
            }

            if (typeof $el.data('user') !== 'undefined' && typeof $el.data('token') !== 'undefined') {
                var feed = new Instafeed(options);
                feed.run();
            }
        }
    });

    return InstagramFeed;
})();

jQuery(function($){
  //Featured collections carousel
  carousel($('.collection-carousel'));
  //Featured products carousel
  carousel($('.product-carousel'));
  //Product thumbnail carousel
  carousel($('.product-single__thumbnails'));
  //Collection page - Add to cart
  $(document).on('click', '.add-to-cart', function(e){
  	e.preventDefault();
    var $el = $(this);
    var addToCartButonText = $(this).html();
    var id = $(this).data('variant-id');
    $.post('/cart/add.js', {quantity: 1, id: id}, function(data){
      $el.html('Added...');
      setTimeout(function(){ $el.html(addToCartButonText); }, 1500);
    }, 'json');
  });
  //Register new sections
  var sections = new theme.Sections();
  sections.register('instagram-feed', theme.InstagramFeed);
  
  /*----- Cart edit on mobile -----*/
  $('.cart__edit .js-edit-toggle').click(function() {
    
    $('.collapse-menu').slideToggle(700);
    return false;
  });  
  
  $('.cart__edit .js-edit-toggle').click(function() {
    $(this).parents('.cart__row').toggleClass("open_edit");
    
  });
  
  
  /*----- Product tab -----*/
  $('ul.tabs li').on('click', function(){
    var tab_id = $(this).attr('data-tab');

    $('ul.tabs li').removeClass('active');
    $('.tab-content').removeClass('active');

    $(this).addClass('active');
    $("#"+tab_id).addClass('active');
  }); 
  
//Menu with scrolling section 
	$('.scroll-trigger a[href^="#"]').on('click', function (e) {
		e.preventDefault();

		var target = this.hash;
		var $target = $(target);

		$('html, body').animate({
			'scrollTop': $target.offset().top
		}, 1000, 'swing');
	});

//Back to top
  // browser window scroll (in pixels) after which the "back to top" link is shown
  var offset = 300,
      //browser window scroll (in pixels) after which the "back to top" link opacity is reduced
      offset_opacity = 1200,
      //duration of the top scrolling animation (in ms)
      scroll_top_duration = 700,
      //grab the "back to top" link
      $back_to_top = $('.cd-top');

  //hide or show the "back to top" link
  $(window).scroll(function(){
    ( $(this).scrollTop() > offset ) ? $back_to_top.addClass('cd-is-visible') : $back_to_top.removeClass('cd-is-visible cd-fade-out');
    if( $(this).scrollTop() > offset_opacity ) { 
      //$back_to_top.addClass('cd-fade-out');
    }
  });

  //smooth scroll to top
  $back_to_top.on('click', function(event){
    event.preventDefault();
    $('body,html').animate({
      scrollTop: 0 ,
    }, scroll_top_duration
    );
  }); 

 //for sticky header
  
 
  
  
  $(window).scroll(function() {    
    var scroll = $(window).scrollTop();

     //>=, not <=
    if (scroll >= 400) {
        //clearHeader, not clearheader - caps H
        $(".sticky-header").addClass("sticky");
    }
    else{
      $('.sticky-header').removeClass("sticky");
    }
})
  
  
  
});


